import { ComponentType } from '@wix/ambassador-devcenter-components-v1-component/types';

export const LEGACY_EDITOR_COMPONENT_TYPES: ComponentType[] = [
  ComponentType.STUDIO,
  ComponentType.PLATFORM,
  ComponentType.WIDGET,
  ComponentType.PAGE,
  ComponentType.STUDIO_WIDGET,
  ComponentType.WEB,
  ComponentType.WIDGET_OUT_OF_IFRAME,
  ComponentType.PAGE_OUT_OF_IFRAME,
  ComponentType.WIDGET_PLUGIN,
  ComponentType.EDITOR_ADDON,
];

export const BI_EVENT_IDS = {
  PLATFORM_INSTALLATION: 114,
  PROVISION_APPS: 115,
  NEW_COMPONENTS_INSTALL: 116,
  UNIFIED_APP_INSTALL: 117,
  INSTALL_CODE_PACKAGES: 118,
  PLATFORM_RUN_SCRIPTS: 119,
  NAVIGATE_TO_DEV_CENTER: 120,
  PLATFORM_ERROR: 121,
  APP_COLLECTION_REPORT: 136,
};

export const APP_SCHEMA_VERSIONS = {
  EXTERNAL_UNIFIED_COMPONENT: 'externalUnifiedComponents',
};

export const UNIFIED_COMPONENTS_PROTO_CHANGES =
  'specs.editor-platform.unified-components-proto-changes';
// TODO: Consume it from document-services-types, should be exported from there first.
export const InvalidPrefixReason = {
  PREFIX_CAN_NOT_BE_EMPTY: 1,
  PREFIX_CONTAINS_INVALID_CHARACTERS: 4,
  PREFIX_IS_DUPLICATE_OF_URI_SEO: 3,
  PREFIX_IS_FORBIDDEN_WORD: 5,
  PREFIX_IS_IN_USE_BY_ANOTHER_APPLICATION: 6,
  PREFIX_IS_TOO_LONG: 2,
} as const;
